<template>
  <div class="activeDetailBox">
    <div class="activeDetail" ref="activeDetail">
      <div class="activeImg">
        <img :src="info.image" alt="活动背景图" />
      </div>
      <div class="activeInfo">
        <div class="titleBox">
          <div class="titleContent">
            <div class="info">
              <p class="name">{{ info.name }}</p>
              <p class="title ellipsis">{{ info.subtitle }}</p>
            </div>
            <p class="count">
              <span>{{ info.signupnum?info.signupnum:0 }}人已报名</span>
              <span>{{ util.showCount(info.reservationcount-(info.signupnum?info.signupnum:0)) }}余票</span>
            </p>
          </div>
        </div>
        <div class="infoList" v-if="info">
          <ul>
            <li class="time" v-if="info.activitytimedes">
              <i></i>
              <div class="text ellipsis">
                {{
                   info.activitytimedes
                }}  
                 <!-- util.changeTime({
                    time: info.activityevens[0].eventenddate,
                    showWeek: true,
                    showMin: true,
                  }) -->
              </div>
            </li>
            <li class="address" v-if="info.address" @click="goAddress()">
              <i></i>
              <div class="text ellipsis">{{ info.address }}</div>
            </li>
          </ul>
        </div>
        <div class="nav" ref="nav">
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="nav ceilingNav" v-if="ceiling">
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="content" v-html="info.memo"></div>
      </div>
    </div>
    <div class="submit">
      <span
        :class="{
          grayBtn:
            this.activeStatus == 3 ||
            this.activeStatus == 4 ||
            this.activeStatus == 5,
        }"
        @click="activeStatus == 1 ? (showBuy = true) : ''"
        >{{ showActive(info) }}</span
      >
    </div>
    <ActivePay
      :showBuy="showBuy"
      :activeId="activeId"
      v-on:payCallback="payCallback"
    ></ActivePay>
    <FreePay v-if="freeObj" :freeObj="freeObj"></FreePay>
  </div>
</template>
<script>
import ActivePay from "./activePay";
import FreePay from "@/components/freePay";
export default {
  name: "activeDetail",
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data() {
    return {
      showBuy: false,
      activeId: "",
      info: "",
      title: "",
      activeStatus: "",
      freeObj: "",
      navList: [{ name: "活动简介" }],
      navIndex: 0,
      ceiling: false,
    };
  },
  components: {
    ActivePay,
    FreePay,
  },
  watch: {},
  created() {
    this.activeId = this.$route.query.activeId? this.$route.query.activeId : "";
    this.getActive();
  },
  mounted() {
    var _this = this;
   _this.$refs.activeDetail.addEventListener("scroll", _this.srollEvent);
  },
  methods: {
    srollEvent() {
      var scrollTop = $(".activeDetail").scrollTop();
      if (scrollTop >= this.navTop && this.navTop > 0) {
        this.ceiling = true;
      } else {
        this.ceiling = false;
      }
    },
    showActive(active) {
      switch (active.activitystatus) {
        case 1000:
        case 1001:
          this.activeStatus = 1;
          return active.price > 0
            ? "立即购票 " + active.price + "元起"
            : "免费报名";
          break;
        case 1002:
          this.activeStatus = 3;
          return "售罄";
          break;
        case 1003:
          this.activeStatus = 5;
          return "停止售票";
          break;
        case 1005:
          this.activeStatus = 4;
          return "已结束";
          break;
      }
    },
    payCallback(data) {
      if (data.type == "close") {
        this.showBuy = false;
      } else if (data.type == "buy") {
        if (data.price > 0) {
          this.$router.push({
            path: "/h5/common/order",
            query: {
              buyNum: data.buyNum,
              ordertype: 1004,
              productid: data.productid,
              tickettype: data.tickettype,
            },
          });
        } else {
          this.showBuy = false;
          this.freeObj = {
            buyNum: data.buyNum,
            ordertype: 1004,
            productid: data.productid,
            tickettype: data.tickettype,
          };
        }
      }
    },
    getActive() {
      var _this = this;
      var obj = {
        activityid: this.activeId,
      };
      this.$post("iart-api-scm/api/scm/activity/queryActivity", obj).then(
        (res) => {
          if (res.code == 1) {
            this.info = res.data;
            this.title = res.data.name;
            this.shareLink();
            setTimeout(() => {
              _this.navTop = _this.$refs.nav.getBoundingClientRect().top;
            }, 300);
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    goAddress() {
      window.location.href="http://api.map.baidu.com/marker?location="+this.info.locationy+','+this.info.locationx+"&content="+this.info.address+"&output=html";
    },
    shareLink() {
      var _this = this;
      var url = _this.$store.state.state.shareUrl +"/h5/index/active/activeDetail?activeId=" +_this.activeId;
      var data = {
        title: this.info.sharetitle,
        desc: this.info.sharesummary ? this.info.sharesummary : "",
        url: url,
        imgUrl: this.info.shareicon,
      };
      this.util.shareLink( data).then(function () {
        _this.shareCount();
      });
    },
    shareCount() {
      this.$post("iart-api-scm/api/scm/activity/createActivitySharecount", {
        activityid: this.activeId,
      }).then((res) => {
        if (res.code == 1) {
        } else {
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.activeDetailBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  .activeDetail {
    flex: 1;
    overflow: auto;
    .activeImg {
      img {
        width: 100%;
        height: auto;
        // height: 45vh;
        // object-fit: cover;
      }
    }
    .activeInfo {
      z-index: 11;
      // margin-top: -70px;
      position: relative;
      .titleBox {
        .titleContent {
          // width: 90vw;
          margin:16px;
          // background: url(../../../../assets/img/h5/courseBg.png) no-repeat;
          // background-size: 100%;
          padding-bottom: 16px;
          margin-bottom: 0;
          border-bottom: 0.5Px solid #E0E0E0;
          .info {
            .name {
              font-size: 22px;
              line-height: 30px;
              color: rgba(51, 54, 51, 1);
              font-weight: bold;
              max-height: 60px;
              overflow: hidden;
            }
            .title {
              font-size: 13px;
              line-height: 18px;
              color: rgba(51, 51, 51, 1);
              margin-top: 4px;
            }
            // padding-bottom: 16px;
            // border-bottom: 0.5Px dashed rgba(53, 54, 60, 1);
          }
          .count {
            margin-top: 16px;
            font-size: 12px;
            line-height: 17px;
            color: rgba(45, 45, 45, 0.6);
            font-weight: 400;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            i {
              display: inline-block;
              width: 4Px;
              height: 4Px;
              border-radius: 50%;
              margin: 0 10px;
              vertical-align: middle;
              background: rgba(120, 110, 118, 1);
            }
            span {
              vertical-align: middle;
            }
          }
        }
      }
      .infoList {
        margin: 0 16px 0;
        li {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 13px 0 0;
          i {
            display: inline-block;
            width: 20px;
            height: 20px;
          }

          .text {
            flex: 1;
            font-size: 12px;
            line-height: 17px;
            color: rgba(51, 51, 51, 1);
            font-weight: 300;
            margin-left: 8px;
            position: relative;
          }
        }
        .time {
          i {
            background: url(../../../../assets/img/h5/date.png) no-repeat;
            background-size: 20px 20px;
          }
        }
        .address {
          i {
            background: url(../../../../assets/img/h5/address_b.png) no-repeat;
            background-size: 20px 20px;
          }
          .text {
            padding-right: 36px;
          }
          .text::before {
            content: " ";
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../../../assets/img/h5/arrow_r_darkgray.png) no-repeat;
            background-size: 24px 24px;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -12px;
          }
        }
        li:not(:last-child) {
          padding-bottom: 16px;
          border-bottom: 0.5Px solid rgba(224, 224, 224, 1);
        }
      }
      .nav {
        margin-top: 7px;
        padding: 0 14px;
        border-bottom: 0.5Px solid rgba(151, 151, 151, 0.2);
        li {
          font-size: 14px;
          line-height: 24px;
          color: rgba(45, 45, 45, 0.85);
          padding: 14px 0;
          position: relative;
          display: inline-block;
        }
        li.active::before {
          content: " ";
          display: inline-block;
          width: 18px;
          height: 2px;
          background: rgba(49, 33, 45, 1);
          position: absolute;
          left: 50%;
          bottom: 0;
          margin-left: -9px;
        }
        li:not(:last-child) {
          margin-right: 12px;
        }
      }
      .ceilingNav {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 11;
        background: #fff;
        margin-top: 0;
      }
      .content {
        padding: 16px;
        image,
        img {
          max-width: 100%;
        }
      }
    }
  }
  .submit {
    background: #fff;
    padding: 16px 24px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
    span {
      display: block;
      padding: 14px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 1);
      font-weight: bolder;
      background: rgba(201, 55, 61, 1);
      border-radius: 3Px;
      text-align: center;
    }
    .grayBtn {
      background: #ededed;
      color: #999;
    }
  }
}
</style>